import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router';

import { Shimmer } from '..';

import { ReactComponent as ArrowLeft } from '../../assets/icons/ubr_arrow_left.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/ubr_arrow_right.svg';
import { ReactComponent as Delete } from '../../assets/icons/ubr_delete.svg';
import { ReactComponent as Edit } from '../../assets/icons/ubr_edit.svg';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import { FaqData, FaqDataDTO } from '../../shared/interfaces/faq';
import Button from '../Button';
import Modal from '../Modal';
import {
  TableContainer,
  FooterTable,
  PageSize,
  ReactSelectCustom,
  Pagination,
  PaginationButton,
  PaginationItem,
} from './styles';

interface TableProps {
  tableData: any | undefined | null;
  headingColumns: string[];
  disableEdit?: boolean;
  disableDelete?: boolean;
  editPagePath?: string;
  titleModal?: string;
  messageModal?: string;
  titleToast: string;
  descriptionToast: string;
}

export const Table: React.FC<TableProps> = ({
  tableData,
  headingColumns,
  disableEdit,
  disableDelete,
  editPagePath,
  titleModal,
  messageModal,
  titleToast,
  descriptionToast,
}) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setitemsPerPage] = useState<number>(5);
  const [pageNumberLimit] = useState<number>(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState<number>(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState<number>(0);
  const history = useHistory();
  const [idToDelete, setIdToDelete] = useState<string>('');
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const { addToast } = useToast();

  const openModal = (id: string) => {
    setIdToDelete(id);
    setShowDeleteModal(true);
  };

  const closeModal = () => {
    setShowDeleteModal(false);
  };

  const data = (tableData as Array<FaqData | FaqDataDTO>).map((row, index) => {
    let rowData: { key: string; val: string | number }[] = [];

    Object.entries(row).forEach((data, i) => {
      rowData.push({
        key: headingColumns[i],
        val: data[1],
      });
    });

    return (
      <>
        <tr key={index}>
          {rowData.map((data: any, index: number) => (
            <>
              <td key={index} data-heading={data.key}>
                <p>
                  {JSON.stringify(data.val).length > 80
                    ? JSON.stringify(data.val).substring(0, 80 - 3) + '...'
                    : data.val}

                  {JSON.stringify(data.val).length > 80 && (
                    <span className="tooltip">{data.val}</span>
                  )}
                </p>
              </td>
            </>
          ))}

          <td data-heading="Ações">
            <div>
              <Button
                color={'#ab934b'}
                variant="solid-icon"
                tooltipText={'Editar'}
                disabled={disableEdit ? true : false}
                onClick={() =>
                  setTimeout(() => {
                    history.push(`${editPagePath}${rowData[0].val}`);
                  }, 500)
                }
              >
                <Edit style={{ width: '20px' }} />
              </Button>
              <Button
                color={'#C71F37'}
                variant="solid-icon"
                tooltipText={'Excluir'}
                disabled={disableDelete ? true : false}
                onClick={() =>
                  setTimeout(() => {
                    openModal(`${rowData[0].val}`);
                  }, 500)
                }
              >
                <Delete style={{ width: '20px' }} />
              </Button>
            </div>
          </td>
        </tr>
      </>
    );
  });

  const deleteCard = async () => {
    closeModal();
    await api.delete(`/tela/${idToDelete}`);

    addToast({
      type: 'success',
      title: titleToast ? titleToast : '',
      description: descriptionToast ? descriptionToast : '',
    });

    history.push(window.location.pathname);
  };

  // Renderizar a tabela

  const renderData = (data: any) => {
    return (
      <div>
        <table id="tableData">
          <thead>
            <tr>
              {headingColumns.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>{data}</tbody>
        </table>
      </div>
    );
  };

  // Funções para realização da paginação

  const handleClick = (event: any) => {
    setCurrentPage(Number(event.target.id));
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
    pages.push(i);
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const renderPageNumbers = pages.map((number: any) => {
    if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
      return (
        <PaginationItem
          key={number}
          id={number}
          onClick={handleClick}
          aria-hidden={typeof number !== 'number' ? 'true' : 'false'}
          aria-label={`${
            typeof number !== 'number' ? '' : `Ir para a página ${number}`
          }`}
          aria-current={number === currentPage}
          style={
            currentPage === number
              ? { border: '1px solid #ab934b', color: '#ab934b' }
              : undefined
          }
        >
          {number}
        </PaginationItem>
      );
    } else {
      return null;
    }
  });

  const handleNextbtn = () => {
    setCurrentPage(currentPage + 1);

    if (currentPage + 1 > maxPageNumberLimit) {
      setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
    }
  };

  const handlePrevbtn = () => {
    setCurrentPage(currentPage - 1);

    if ((currentPage - 1) % pageNumberLimit === 0) {
      setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
    }
  };

  let pageIncrementBtn = null;
  if (pages.length > maxPageNumberLimit) {
    pageIncrementBtn = (
      <PaginationItem onClick={handleNextbtn}> &hellip; </PaginationItem>
    );
  }

  let pageDecrementBtn = null;
  if (minPageNumberLimit >= 1) {
    pageDecrementBtn = (
      <PaginationItem onClick={handlePrevbtn}> &hellip; </PaginationItem>
    );
  }

  const limits = useCallback(e => {
    setitemsPerPage(e.value);
    setCurrentPage(1);
  }, []);

  const options = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 50, label: 50 },
  ];

  const loadingTable = () => {
    return (
      <>
        <tr>
          {headingColumns.map(index => (
            <td key={index}>
              <p
                style={{
                  width: '100%',
                  height: '40px',
                  overflow: 'hidden',
                  borderRadius: '4px',
                }}
              >
                <Shimmer />
              </p>
            </td>
          ))}
          <td>
            <p
              style={{
                width: '100%',
                height: '40px',
                overflow: 'hidden',
                borderRadius: '4px',
              }}
            >
              <Shimmer />
            </p>
          </td>
        </tr>
        <tr>
          {headingColumns.map(index => (
            <td key={index}>
              <p
                style={{
                  width: '100%',
                  height: '40px',
                  overflow: 'hidden',
                  borderRadius: '4px',
                }}
              >
                <Shimmer />
              </p>
            </td>
          ))}
          <td>
            <p
              style={{
                width: '100%',
                height: '40px',
                overflow: 'hidden',
                borderRadius: '4px',
              }}
            >
              <Shimmer />
            </p>
          </td>
        </tr>
        <tr>
          {headingColumns.map(index => (
            <td key={index}>
              <p
                style={{
                  width: '100%',
                  height: '40px',
                  overflow: 'hidden',
                  borderRadius: '4px',
                }}
              >
                <Shimmer />
              </p>
            </td>
          ))}
          <td>
            <p
              style={{
                width: '100%',
                height: '40px',
                overflow: 'hidden',
                borderRadius: '4px',
              }}
            >
              <Shimmer />
            </p>
          </td>
        </tr>
      </>
    );
  };

  // =========================================================================================

  return (
    <>
      <Modal
        show={showDeleteModal}
        titulo={titleModal ? titleModal : 'Excluir Tela'}
        mensagem={messageModal ? messageModal : 'Confirma a exclusão?'}
        onConfirm={() => deleteCard()}
        onCancel={() => closeModal()}
        actionButtons
      />
      <TableContainer>
        {renderData(data.length <= 0 ? loadingTable() : currentItems)}
        <FooterTable>
          <PageSize>
            Dados por página
            <ReactSelectCustom
              classNamePrefix="react-select"
              onChange={limits}
              options={options}
              defaultValue={itemsPerPage}
              placeholder={5}
              isSearchable={false}
            />
          </PageSize>
          <Pagination>
            <PaginationButton aria-label="Paginação">
              <PaginationItem
                onClick={handlePrevbtn}
                disabled={
                  currentPage === pages[0]
                    ? true
                    : false || pages.length <= 1
                    ? true
                    : false
                }
                aria-label={`Voltar ${
                  currentPage === 1
                    ? 'página'
                    : `para página ${currentPage - 1}`
                }`}
                tabIndex={currentPage === pages[pages.length - 1] ? -1 : 0}
                aria-disabled={
                  currentPage === pages[pages.length - 1] ? 'true' : 'false'
                }
              >
                <ArrowLeft />
              </PaginationItem>
              {pageDecrementBtn}
              {renderPageNumbers}
              {pageIncrementBtn}
              <PaginationItem
                onClick={handleNextbtn}
                disabled={
                  currentPage === pages[pages.length - 1]
                    ? true
                    : false || pages.length <= 1
                    ? true
                    : false
                }
                aria-label={`Avançar ${
                  currentPage === pages[pages.length - 1]
                    ? 'página'
                    : `para página ${currentPage + 1}`
                }`}
                tabIndex={currentPage === pages[pages.length - 1] ? -1 : 0}
                aria-disabled={
                  currentPage === pages[pages.length - 1] ? 'true' : 'false'
                }
              >
                <ArrowRight />
              </PaginationItem>
            </PaginationButton>
          </Pagination>
        </FooterTable>
      </TableContainer>
    </>
  );
};

export default Table;
